export var Screen = /*#__PURE__*/function (Screen) {
  Screen[Screen["PAYMENT"] = 0] = "PAYMENT";
  Screen[Screen["SUCCESS"] = 1] = "SUCCESS";
  return Screen;
}({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/components/WtOneClick/types.js
// module id = 910
// module chunks = 11